module.exports = __webpack_public_path__ + "static/img/4-1-5.87f96d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-1-5.png
// module id = 9mu7
// module chunks = 12